import react, { useEffect, useState } from "react";
import { Box, Button, Select, MenuItem, FormControl, InputLabel, TextField } from "@mui/material";
import IconCamera from "../../componentsStyled/icon/Iconcamera";
import ModalCamera from "../../components/modalfoto";
import OutOfDateModal from "../../components/OutOfDateModal";
import LoadingBox from "../../components/LoadingBox";
import { isMobile } from "react-device-detect";
import apiConnect from "../../api/apiConnect";

interface ProductSelectedPropsType {
  produto: any;
  delivery_date: any;
  pedidoID: any;
  updateProdutoData: (productId: any, key: any, value: any, variant_value: any) => void;
}
interface deadlinesType {
  "Troca por Tamanho": string;
  "Produto Divergente": string;
  Personalização: string;
  "Defeito no Produto": string;
  Arrependimento: string;
}

interface reasonsDevolutiontype {
  id: number;
  description: string;
  display_to_customer: string;
  media_required: number;
  days_allowed: number;
  subReasons: Array<{
    id: number;
    description: string;
    display_to_customer: number;
  }>;
}

const BoxProductDevolution: React.FC<ProductSelectedPropsType> = ({ produto, updateProdutoData, delivery_date, pedidoID }) => {
  //Vars States
  //loads
  const [loadReasons, setloadReasons] = useState<boolean>(true);

  //vars
  const [reasons, setReasons] = useState<reasonsDevolutiontype[]>();
  const [reasonDeadlines, setReasonDeadlines] = useState<deadlinesType>({} as deadlinesType);
  const [reasonPrime, setreasonPrime] = useState<any>("");
  const [subReasons, setSubReasons] = useState<any[]>([]);
  const [photoRequire, setPhotoRequire] = useState<boolean>(false);
  const [openModalPhoto, setOpenModalPhoto] = useState<boolean>(false);
  const [outOfDateModalIsOpen, setOutOfDateModalIsOpen] = useState<boolean>(false);
  const [selectedReasonDaysAllowed, setSelectedReasonDaysAllowed] = useState<number | null>(null);

  const handlePhotoUploadComplete = (variant_value: any) => {
    updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "fotoAdicionada", true, variant_value);
    setPhotoRequire(false);
  };

  //  Buscar os motivos na API e validações
  const heandleGetReasons = async () => {
    setloadReasons(true);
    const formatDate = (baseDate: any, daysToAdd: any) => {
      const deadlineDate = new Date(baseDate);
      deadlineDate.setDate(deadlineDate.getDate() + daysToAdd);

      const year = deadlineDate.getFullYear();
      const month = String(deadlineDate.getMonth() + 1).padStart(2, "0");
      const day = String(deadlineDate.getDate()).padStart(2, "0");

      return `${year}-${month}-${day} 00:00:00`;
    };
    apiConnect.apiAPP
      .get("reasons")
      .then((resp) => {
        setReasons(resp.data);
        const deadlines: deadlinesType = {} as deadlinesType;
        resp.data.forEach((reason: any) => {
          const currentDate = new Date();
          const deadlineDate = new Date(currentDate);
          deadlineDate.setDate(currentDate.getDate() + reason.days_allowed);
          const formattedDeadlineDate = formatDate(delivery_date, reason.days_allowed);
          deadlines[reason.description] = formattedDeadlineDate;
        });
        setReasonDeadlines(deadlines);
        setloadReasons(false);
      })
      .catch((error) => {
        console.error("Error fetching reasons:", error);
        setloadReasons(false);
      });
  };
  //  Buscar os motivos na API e validações

  //useEffects
  // Monitora select motivo principal
  useEffect(() => {
    reasons?.length > 0 &&
      reasons.map((reason) => {
        if (reason.description == reasonPrime) {
          setSubReasons(reason.subReasons);
          updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "productSoldId", produto.product_sold_id, produto.variant_value);

          setSelectedReasonDaysAllowed(reason.days_allowed);
          if (reason.media_required == 1) {
            setPhotoRequire(true);
            updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "photoRequire", true, produto.variant_value);
          } else {
            updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "photoRequire", false, produto.variant_value);
            setPhotoRequire(false);
          }
        }
      });

    const deadlineDate = new Date(reasonDeadlines[reasonPrime]);
    const currentDate = new Date();

    if (currentDate > deadlineDate) {
      setOutOfDateModalIsOpen(true);
      updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "motivoDevolucao", "", produto.variant_value);
      setreasonPrime("#");
    }
  }, [reasonPrime]);

  // Load Reasons
  useEffect(() => {
    heandleGetReasons();
  }, []);

  if (loadReasons) {
    return (
      <Box border={"1px solid #ccc"} padding={2} borderRadius={5} width={{ xs: "90%", md: "40%" }}>
        <LoadingBox loadType="static" />
      </Box>
    );
  } else {
    return (
      <Box border={"1px solid #ccc"} padding={1} borderRadius={5} width={{ xs: "auto", md: 700 }} bgcolor={"#fff"}>
        {isMobile ? (
          <Box display={"flex"} flexDirection={"column"} gap={2}>
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={2}>
              <a href={produto.url} target="_blank">
                <img style={{ width: "25vw", borderRadius: 15 }} src={produto.img} alt={produto.name} />
              </a>
              <Box display={"flex"} gap={2} flexDirection={"column"}>
                <p
                  style={{
                    fontFamily: "Gotham",
                    fontSize: 21,
                    letterSpacing: 1,
                    fontWeight: 700,
                    textOverflow: "ellipsis",
                    lineClamp: 1,
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }}>
                  {produto.name}
                </p>
                <span>Variação: {produto.variant_value}</span>
                {/* <span>soldID: {produto.product_sold_id}</span> */}
              </Box>
            </Box>
            <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={5}>
              <Select
                onChange={(selectedValue) => {
                  updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "quantidade", selectedValue.target.value, produto.variant_value);
                }}
                defaultValue={"#"}
                sx={{ borderRadius: 10, minWidth: 100, height: 40, borderColor: "#222020" }}>
                <MenuItem value={"#"}>Quantidade</MenuItem>
                {Array.from({ length: produto.quantity }, (_, i) => i + 1).map((item, i) => {
                  return (
                    <MenuItem key={`${i}_${item}`} value={item}>
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
              <Box>
                <Button
                  sx={{ gap: 1, margin: 0, padding: 0 }}
                  variant="text"
                  onClick={() => {
                    setOpenModalPhoto(true);
                  }}>
                  <IconCamera fill="#000" width={40} />
                  <p style={{ color: "#000", fontSize: 12 }}>Anexar Foto</p>
                </Button>
                {photoRequire ? (
                  <p
                    style={{
                      color: "#ff0000",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}>
                    * Necessario envio de fotos é obrigatório
                  </p>
                ) : null}
              </Box>
            </Box>
          </Box>
        ) : (
          <Box display={"flex"} flexDirection={"row"} gap={2}>
            <a href={produto.url} target="_blank">
              <img style={{ width: 150, borderRadius: 15 }} src={produto.img} alt={produto.name} />
            </a>
            <Box display={"flex"} gap={2} flexDirection={"column"}>
              <p
                style={{
                  fontFamily: "Gotham",
                  fontSize: 21,
                  letterSpacing: 1,
                  fontWeight: 700,
                  textOverflow: "ellipsis",
                  lineClamp: 1,
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                }}>
                {produto.name}
              </p>
              <span>Variação: {produto.variant_value}</span>
              {/* <span>soldID: {produto.product_sold_id}</span> */}
              <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={5}>
                <Box>
                  <Button
                    sx={{ gap: 1, margin: 0, padding: 0 }}
                    variant="text"
                    onClick={() => {
                      setOpenModalPhoto(true);
                    }}>
                    <IconCamera fill="#000" width={45} />
                    <p style={{ color: "#000" }}>Anexar Foto</p>
                  </Button>
                  {photoRequire ? (
                    <p
                      style={{
                        color: "#ff0000",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}>
                      * Necessario envio de fotos é obrigatório
                    </p>
                  ) : null}
                </Box>
                <Select
                  onChange={(selectedValue) => {
                    updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "quantidade", selectedValue.target.value, produto.variant_value);
                  }}
                  defaultValue={"#"}
                  sx={{ borderRadius: 10, minWidth: 100, height: 40, borderColor: "#222020" }}>
                  <MenuItem value={"#"}>Quantidade</MenuItem>
                  {Array.from({ length: produto.quantity }, (_, i) => i + 1).map((item, i) => {
                    return (
                      <MenuItem key={`${i}_${item}`} value={item}>
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Box>
            </Box>
          </Box>
        )}

        <Box display={"flex"} flexDirection={"column"} gap={2}>
          <FormControl variant="standard" sx={{ m: 1, width: { xs: 300, md: "20vw" } }}>
            <InputLabel>*Por que quer devolver?</InputLabel>
            <Select
              variant="standard"
              onChange={(selectedValue) => {
                updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "motivoDevolucao", selectedValue.target.value, produto.variant_value);
                setreasonPrime(selectedValue.target.value);
              }}
              defaultValue={"#"}>
              <MenuItem value="#" disabled>
                Selecione uma opção
              </MenuItem>
              {reasons.map((reason, i) => {
                if (reason.display_to_customer == "1") {
                  return (
                    <MenuItem key={`${i}_${reason.description}`} value={reason.description}>
                      {reason.description}
                    </MenuItem>
                  );
                }
              })}
            </Select>
          </FormControl>

          <FormControl variant="standard" sx={{ m: 1, width: { xs: 300, md: "20vw" } }}>
            <InputLabel>*O que aconteceu?</InputLabel>
            <Select
              variant="standard"
              onChange={(selectedValue) => {
                updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "subDevolucao", selectedValue.target.value, produto.variant_value);
              }}
              defaultValue={"#"}>
              <MenuItem value="#" disabled>
                Selecione uma opção
              </MenuItem>

              {subReasons.map((subReason, i) => {
                if (subReason.display_to_customer == "1") {
                  return (
                    <MenuItem key={`${i}_${subReason.description}`} value={subReason.id}>
                      {subReason.description}
                    </MenuItem>
                  );
                }
              })}
            </Select>
          </FormControl>

          <Box display={"flex"} gap={{ xs: 1, md: 5 }} flexDirection={{ xs: "column", md: "row" }}>
            <FormControl variant="standard" sx={{ m: 1, width: { xs: 300, md: "20vw" } }}>
              <InputLabel>*Tipo de Reembolso</InputLabel>
              <Select
                variant="standard"
                onChange={(selectedValue) =>
                  updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "tipoReembolso", selectedValue.target.value, produto.variant_value)
                }
                defaultValue={"#"}>
                <MenuItem disabled value="#">
                  Selecione uma opção
                </MenuItem>
                <MenuItem value="Cupom">Cupom</MenuItem>
                <MenuItem value="Estorno">Estorno</MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Observações"
              variant={"outlined"}
              multiline
              maxRows={4}
              onChange={(e) => updateProdutoData(`${produto.product_id}-${produto.product_sold_id}`, "obsDev", e.target.value, produto.variant_value)}
            />
          </Box>
        </Box>

        {/* Modal Add foto Produto */}
        <ModalCamera
          isOpen={openModalPhoto}
          pedidoID={pedidoID}
          onRequestClose={() => setOpenModalPhoto(false)}
          dadosSelecionados={produto}
          onPhotoUploadComplete={() => handlePhotoUploadComplete(produto.variant_value)}
        />
        {/* Modal Add foto Produto */}

        {/* prazo de troca vencido */}
        <OutOfDateModal isOpen={outOfDateModalIsOpen} onRequestClose={() => setOutOfDateModalIsOpen(false)} daysAllowed={selectedReasonDaysAllowed} />
        {/* prazo de troca vencido */}
      </Box>
    );
  }
};

export default BoxProductDevolution;
